import { render } from "./Top.vue?vue&type=template&id=946ecb8a&scoped=true"
import script from "./Top.vue?vue&type=script&lang=js"
export * from "./Top.vue?vue&type=script&lang=js"

import "./Top.vue?vue&type=style&index=0&id=946ecb8a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-946ecb8a"

export default script